import { useContext, useState } from "react";
import PropTypes from "prop-types";
import styled, { withTheme } from "styled-components";
import { getTooltipDefaultAttributes } from "../Tooltip";
import Paragraph from "./Paragraph";
import { themeProp } from "../../theme";
import { PrintContext } from "../../providers/PrintProvider";

const TruncatedTitle = ({
  fullText,
  rows,
  placement,
  children,
  theme,
  level,
  ...props
}) => {
  const [truncatedInternal, setTruncated] = useState(false);
  const { isPrint } = useContext(PrintContext);

  const onEllipsisInternal = (ellipsis) => {
    setTruncated(ellipsis);
  };

  return (
    <Container
      className={truncatedInternal && !isPrint ? "hasToolip" : undefined}
      level={level}
      isPrint={isPrint}
    >
      <Paragraph
        ellipsis={
          !isPrint
            ? {
                rows,
                tooltip: {
                  title: fullText,
                  placement,
                  ...getTooltipDefaultAttributes({ theme })
                },
                onEllipsis: onEllipsisInternal
              }
            : undefined
        }
        {...props}
      >
        {children}
      </Paragraph>
    </Container>
  );
};

const Container = styled.div`
  &.hasToolip {
    cursor: help;
  }

  & > div {
    font-size: ${({ level, isPrint }) =>
      isPrint && level === 5
        ? "11px"
        : themeProp(`typography.h${level}.fontSize`)} !important;
    font-family: ${({ level }) =>
      themeProp(`typography.h${level}.fontFamily`)} !important;
    font-weight: ${({ level }) =>
      themeProp(`typography.h${level}.fontWeight`)} !important;
    ${(props) =>
      props.color
        ? "color: " +
          themeProp(`palette.${props.color}`)(props) +
          " !important;"
        : ""}
    ${({ level }) =>
      level === 5 ? `text-transform: uppercase !important;` : ""}
        text-align: center;
  }
`;

TruncatedTitle.propTypes = {
  fullText: PropTypes.any,
  placement: PropTypes.string,
  level: PropTypes.number
};

TruncatedTitle.defaultProps = {
  placement: "top",
  rows: 2,
  level: 5
};

export default withTheme(TruncatedTitle);
